import { Component, ChangeDetectionStrategy, Input, Inject, LOCALE_ID, Output, EventEmitter } from '@angular/core';

@Component({
  selector: 'kgr-menu-language-switch',
  templateUrl: './menu-language-switch.component.html',
  styleUrls: ['./menu-language-switch.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [],
})
export class MenuLanguageSwitchComponent {
  @Input() locales: string[] = [];
  @Output() localeChanged = new EventEmitter<string>();

  readonly languageNames: Record<string, string> = {
    de: 'Deutsch',
    en: 'English',
    es: 'Español',
    tr: 'Türkçe',
    uk: 'Українська',
  };

  constructor(@Inject(LOCALE_ID) public activeLocaleId: string) {}

  getLanguageName(localeId: string): string {
    return this.languageNames[localeId] || localeId;
  }

  onLocaleSelected(event: Event) {
    const select = event.target as HTMLSelectElement;
    this.localeChanged.emit(select.value);
  }
}
